import store from '../store'
let instance;
class ResizeEvent {
    constructor(){
        if(instance) return instance;
        instance = this;
        window.addEventListener('resize', e =>{
            let t = window, a = 'inner';
            let breakPoint = 'pc';
            if (!('innerWidth' in window )) {
                a = 'client';
                t = document.documentElement || document.body;
            }
             store.commit('setDocumentSize', {w:t[ a+'Width' ], h:t[ a+'Height' ]})
            if(t[ a+'Width' ] <= 360){
                breakPoint = 'mobile';
            }else if(t[ a+'Width' ] > 360 && t[ a+'Width' ] <= 768){
                breakPoint = 'mobile';
            }else if(t[ a+'Width' ] > 768 && t[ a+'Width' ] <= 960){
                breakPoint = 'tablet';
            }else if(t[ a+'Width' ] > 960){
                breakPoint = 'pc';
            }
            store.commit('setBreakPoint', breakPoint)
        })
        window.dispatchEvent(new CustomEvent('resize'));
    }
}

new ResizeEvent();